import latinize from "latinize";

export class StringHelper {
  static latinize = (value: string) => latinize(value);
}
